import { createSlice } from "@reduxjs/toolkit";


export const defaultFormState = {
  discountName: "",
  promoCode: "",
  discountType: "percentage",
  value: null,
  usageLimit: null,
  expiryDate: null,
  userIds: "",
  usageCount: 0,
};

const initialState = {
    "editingId":null,
    "formState": defaultFormState,
    "viewMode": "list"
}

export const promoCodeSlice = createSlice({
  name: "roomType",
  initialState,

  reducers: {
    setViewMode:(state, action) => {
      state.viewMode = action.payload;
    },
    setEditingId:(state, action) => {
      state.editingId = action.payload;
    },
    setFormState:(state, action) => {
      state.formState = action.payload;
    },
    setStateOnOpenAddPromoCode: (state, action) => {
      state.editingId = null;
      state.formState = defaultFormState;
      state.viewMode = "form"
    }
  }
});

export const {
  setViewMode,
  setEditingId,
  setFormState,
  setStateOnOpenAddPromoCode,
} = promoCodeSlice.actions;

export default promoCodeSlice.reducer;